<template>
  <div>
    <div>
      <a
        :href="downloadAllLink"
        class="download__linkDownloadAll"
        target="_blank"
      >
        Alle Daten in Monatssummen herunterladen
        <IconExternal />
      </a>
      <br /><em
    >Info: es handelt sich hier um Rohdaten. Die geeichten Messwerte finden
      sich auf der Monats- bzw. Jahresabrechnung.</em
    >
    </div>
    <template v-if="downloads.length > 0">
      <div class="download" v-for="download in downloads" :key="download.name">
        <div class="download__label">
          {{ download.caption }}
        </div>
        <a
          :href="download.fifteenMinUrl"
          class="download__link"
          target="_blank"
        >
          {{ download.fifteenMinCaption }}
          <IconExternal />
        </a>
        <a :href="download.dailyUrl" class="download__link2nd" target="_blank">
          {{ download.dailyCaption }}
          <IconExternal />
        </a>
      </div>
    </template>
    <div class="downloads__empty" v-else>
      {{ t('settings.noDownloads') }}
    </div>
  </div>
</template>

<script setup>
  import IconExternal from '@/components/icons/External.vue'
  import { useStrings } from '@/composables/useStrings.ts'
  import { useDownloads } from '@/composables/useDownloads.ts'
  import { onMounted } from 'vue'

  const { t } = useStrings()
  const { downloads, downloadAllLink, load } = useDownloads()

  onMounted(load)
</script>

<style lang="scss">
  .downloads {
    &__filter {
      margin-bottom: $spacer20;

      &-label {
        display: inline-block;
        line-height: 2rem;
        margin-right: $spacer10;
      }
    }
  }

  .download {
    margin-top: $spacer10;

    @media (min-width: $bp-sm) {
      display: flex;
      margin-top: $spacer05;
    }

    &__label {
      line-height: $line-height-sm;
      color: $grey-dark;
      flex-basis: 25%;

      @media (min-width: $bp-sm) {
        font-size: $font-size-lg;
        line-height: $line-height-base;
      }
    }

    &__link {
      font-size: $font-size-lg;
      color: $body-color;
      transition: $transition-base;

      .icon {
        width: 1em;
        display: inline-block;
        vertical-align: middle;
      }
    }

    &__link2nd {
      font-size: $font-size-lg;
      color: $body-color;
      padding-left: 2em;

      .icon {
        width: 1em;
        display: inline-block;
        vertical-align: middle;
      }
    }

    &__linkDownloadAll {
      font-size: $font-size-lg;
      color: $body-color;
      transition: $transition-base;

      .icon {
        width: 1em;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
</style>
